
import { getAccessLog } from '@/apis/systemAPI'
import { SET_HAVE_NEW_EXPORT_RECORD } from '@/store/actions'
import { EExportType } from '@/utils/enums'
import errorHandler from '@/utils/errorHandler'
import { isAfterDate } from '@/utils/utils'
import moment from 'moment'
import { Options, Vue } from 'vue-class-component'

@Options({
  name: 'AccessLogOutput',
})
export default class AccessLogOutput extends Vue {
  isShowDialog = false
  loading = false
  dateModel: Record<string, string> = { date: moment().toString() }

  openAccessLogOutput() {
    this.isShowDialog = true
  }

  disabledDate(date: Date) {
    return isAfterDate(date)
  }

  onCloseDialog() {
    this.isShowDialog = false
  }

  onChangeMonth(month: number) {
    return month.toString().length < 2 ? '0' + month.toString() : month.toString()
  }

  async onExportBarcode() {
    try {
      this.loading = true
      const month = this.onChangeMonth(new Date(this.dateModel.date).getMonth() + 1)
      const year = new Date(this.dateModel.date).getFullYear()
      await getAccessLog(`${year}-${month}`)
      this.$store.commit(SET_HAVE_NEW_EXPORT_RECORD, { exportType: EExportType.ACCESS_LOG, isHaveNew: true })
    } catch (error) {
      errorHandler(error)
    } finally {
      this.loading = false
      this.isShowDialog = false
    }
  }
}
